import React, { useEffect } from 'react';
import { TriggerProps } from 'src/feature-app';
import { GTI50ProspectsForm } from 'src/forms';

export function GTI50Controller({
	setSelectedJourney,
}: TriggerProps): JSX.Element {
	useEffect(() => {
		setSelectedJourney(<GTI50ProspectsForm />, true);
	}, []);

	return null;
}
